module.exports = __webpack_public_path__ + "img/background.10eb7e9d.png";